export const logError = (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.error(...args);
};

export const logInfo = (...args: unknown[]) => {
    if (__IS_DEV__ || __IS_STAGE__) {
        // eslint-disable-next-line no-console
        console.info(...args);
    }
};

export const logWarn = (...args: unknown[]) => {
    if (__IS_DEV__ || __IS_STAGE__) {
        // eslint-disable-next-line no-console
        console.warn(...args);
    }
};

export const log = (...args: unknown[]) => {
    if (__IS_DEV__ || __IS_STAGE__) {
        // eslint-disable-next-line no-console
        console.log(...args);
    }
};
